/* eslint-disable lingui/text-restrictions */
/* eslint-disable lingui/no-unlocalized-strings */

import { Trans } from "@lingui/macro";
import { Button } from "@stylingcv/ui";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { ResumeAnimation } from "./resume-animation";

export const ATSOptimizationSection = () => {
  return (
    <section className="relative overflow-hidden bg-[#fdfcfb] py-16 sm:py-20 lg:py-24">
      {/* Background gradient effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#e7eeff]/40 via-background to-[#fdfcfb]" />

        {/* Warm brown glow on the right */}
        <div className="absolute -right-1/4 top-1/2 size-96 -translate-y-1/2 rounded-full bg-gradient-to-br from-[#8B5A2B]/20 via-[#6B4C2C]/20 to-[#4A3A2A]/20 blur-3xl" />

        {/* Warm brown glow on the left bottom */}
        <div className="absolute -left-1/4 bottom-0 size-96 rounded-full bg-gradient-to-tr from-[#6B4C2C]/20 to-[#8B5A2B]/20 blur-3xl" />

        {/* Decorative lines */}
        <svg className="absolute inset-0 size-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path
                d="M 40 0 L 0 0 0 40"
                fill="none"
                stroke="white"
                strokeWidth="0.1"
                opacity="0.1"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />

          {/* Diagonal lines */}
          <line
            x1="100%"
            y1="0"
            x2="80%"
            y2="100%"
            stroke="white"
            strokeWidth="0.5"
            opacity="0.05"
          />
          <line
            x1="90%"
            y1="0"
            x2="70%"
            y2="100%"
            stroke="white"
            strokeWidth="0.5"
            opacity="0.05"
          />
          <line
            x1="80%"
            y1="0"
            x2="60%"
            y2="100%"
            stroke="white"
            strokeWidth="0.5"
            opacity="0.05"
          />
        </svg>
      </div>

      <div className="container relative z-10">
        <div className="mx-auto max-w-6xl">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            {/* Left side - Content */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="mb-6 text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
                <Trans>Resumes optimized for applicant tracking systems (ATS)</Trans>
              </h2>

              <p className="mb-8 text-lg text-muted-foreground">
                <Trans>
                  Enhancv resumes and cover letters are vigorously tested against major ATS systems
                  to ensure complete parsability
                </Trans>
              </p>

              <Link to="/auth/register">
                <Button
                  size="lg"
                  className="rounded-lg bg-gradient-to-r from-primary to-accent px-8 py-3 font-semibold text-primary-foreground shadow-lg transition-all hover:opacity-90 hover:shadow-xl"
                >
                  <Trans>Build an ATS-Friendly Resume</Trans>
                </Button>
              </Link>
            </motion.div>

            {/* Right side - Animated Resume Showcase */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative flex items-center justify-center"
            >
              <ResumeAnimation />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
